import type { LocaleMessageBundle } from '../../types'

export const authLoginMessages: LocaleMessageBundle = {
  vi: {
    'auth.login.model': 'Tài khoản',
    'auth.login.title': 'Đăng nhập BigSale',
    'auth.login.subtitle': 'Quản lý bán hàng và vận hành POS billiards',
    'auth.login.fields.tenantCode': 'Mã cửa hàng',
    'auth.login.fields.username': 'Tên đăng nhập',
    'auth.login.fields.password': 'Mật khẩu',
    'auth.login.fields.remember': 'Ghi nhớ đăng nhập',
    'auth.login.placeholders.tenantCode': 'Ví dụ: demo',
    'auth.login.placeholders.username': 'Nhập tên đăng nhập, email hoặc số điện thoại',
    'auth.login.placeholders.password': 'Nhập mật khẩu',
    'auth.login.actions.forgotPassword': 'Quên mật khẩu?',
    'auth.login.actions.submit': 'Đăng nhập',
    'auth.login.actions.submitting': 'Đang đăng nhập...',
    'auth.login.actions.success': 'Đăng nhập thành công.',
    'auth.login.actions.failed': 'Đăng nhập không thành công.',
    'auth.login.errors.invalidCredentials': 'Tên đăng nhập hoặc mật khẩu không đúng.',
    'auth.login.meta.version': 'BigSale POS v1.0.1',
    'auth.login.language': 'Ngôn ngữ',
    'auth.login.errors.mockError': 'Thông tin đăng nhập không hợp lệ',
  },
  en: {
    'auth.login.model': 'Account',
    'auth.login.title': 'Sign in to BigSale',
    'auth.login.subtitle': 'Manage billiards POS sales and operations',
    'auth.login.fields.tenantCode': 'Tenant code',
    'auth.login.fields.username': 'Username',
    'auth.login.fields.password': 'Password',
    'auth.login.fields.remember': 'Remember me',
    'auth.login.placeholders.tenantCode': 'Example: demo',
    'auth.login.placeholders.username': 'Enter username, email, or phone number',
    'auth.login.placeholders.password': 'Enter password',
    'auth.login.actions.forgotPassword': 'Forgot password?',
    'auth.login.actions.submit': 'Login',
    'auth.login.actions.submitting': 'Logging in...',
    'auth.login.actions.success': 'Logged in successfully.',
    'auth.login.actions.failed': 'Login failed.',
    'auth.login.errors.invalidCredentials': 'Invalid username or password.',
    'auth.login.meta.version': 'BigSale POS v1.0.1',
    'auth.login.language': 'Language',
    'auth.login.errors.mockError': 'Invalid login information',
  },
}
